import React, { useEffect, useState } from "react";
import "./drawer_modal.scss";
import Button from "b2b-ui-components-lib/lib/components/button";
import DownloadExcel from "../../../dedicated/components/downloadExcel/downloadExcel";
import UploadExcel from "../../../dedicated/components/uploadExcel/uploadExcel";

function Drawer({
  isOpen,
  setIsOpen,
  onSave,
  disabled,
  headingTitle,
  drawerContent,
  showOnlyClose,
  isLoading = false,
}) {
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    const footerHeight = document.querySelector(".drawer_footer").offsetHeight;
    const headerHeight = document.querySelector(".drawer_header").offsetHeight;
    setContentHeight(footerHeight + headerHeight);
  }, []);

  return (
    <div className={`drawer_modal_controller ${isOpen ? "active" : ""}`}>
      <div className="drawer">
        <div className="drawer_header">
          <div className="container">
            <div className="drawer_head">
              <div className="title_info">
                <div className="title_heading">{headingTitle}</div>
              </div>
              <span
                className="close_icon"
                onClick={() => setIsOpen(false)}
              ></span>
            </div>
          </div>
        </div>
        <div className="drawer_body">
          <div className="scroll_content">
            <div className="container">{drawerContent}</div>
          </div>
        </div>
        <div className="drawer_footer">
          <div className="container">
            <div className="button_group">
              {!showOnlyClose && (
                <React.Fragment>
                  <Button variant="outlinebtn" onClick={() => setIsOpen(false)}>
                    Cancel
                  </Button>
                  <Button disabled={disabled || isLoading} onClick={onSave}>
                    Save
                    {isLoading && <span className="loading_icon"></span>}
                  </Button>
                </React.Fragment>
              )}

              {/* {
                 showOnlyClose &&
                  <Button variant="outlinebtn" onClick={() => setIsOpen(false)}>
                   Close
                 </Button>
               } */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Drawer;
